import usePrevious from 'hooks/usePrevious'
import { startTransition, useCallback, useEffect, useState } from 'react'

export const METASEARCH_LOAD_MORE_BATCH_SIZE = 3

// Render secondary YMAL tiles progressively so SSR and initial hydration can
// prioritise the primary offer and immediately useful secondary results.
function useProgressiveYmalTileCount(
  listKey: string | undefined,
  sortMode: string,
  priorityTileCount: number,
  availableTileCount: number,
): [number, () => void] {
  const displayListKey = `${listKey ?? 'disabled'}:${sortMode}:${priorityTileCount}`
  const previousDisplayListKey = usePrevious(displayListKey, displayListKey)
  const hasDisplayListChanged = previousDisplayListKey !== displayListKey
  const [tileCount, setTileCount] = useState(priorityTileCount)
  const displayedTileCount = hasDisplayListChanged ? priorityTileCount : tileCount

  useEffect(() => {
    setTileCount(priorityTileCount)
  }, [displayListKey, priorityTileCount])

  const loadMore = useCallback(() => {
    startTransition(() => {
      setTileCount(currentTileCount => Math.min(
        (hasDisplayListChanged ? priorityTileCount : currentTileCount) + METASEARCH_LOAD_MORE_BATCH_SIZE,
        availableTileCount,
      ))
    })
  }, [availableTileCount, hasDisplayListChanged, priorityTileCount])

  return [displayedTileCount, loadMore]
}

export default useProgressiveYmalTileCount
